var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 228.54 191.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10.08,
    y1: 125.56,
    x2: 59.37,
    y2: -0.53,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c9aa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9aa9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 230.73,
    y1: 137.09,
    x2: 173.77,
    y2: -0.52,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d9aa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9aa9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 113.76,
    y1: 102.97,
    x2: 127.26,
    y2: 2.97,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#bac1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4dc",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 114.26,
    y1: 194,
    x2: 114.26,
    y2: 115.76,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 116.09,
    y1: 145.56,
    x2: 111.97,
    y2: 177.72,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "misc-table-new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.15,56H0l11.12,79.32.77,52.52a3.31,3.31,0,0,0,6.62,0L20,136.24H60l.75,51.82a3.1,3.1,0,0,0,6.19,0l.76-51.86a2.41,2.41,0,0,0,1.56-3.88c-5.39-6.91-14-9.46-22.7-9.85A78.71,78.71,0,0,0,22,125.85a1.44,1.44,0,0,1-1.84-1.06L6.63,60.45A5.6,5.6,0,0,0,1.15,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.39,56a5.61,5.61,0,0,0-5.48,4.45l-13.55,64.34a1.45,1.45,0,0,1-1.84,1.06,78.82,78.82,0,0,0-24.58-3.38c-8.74.39-17.31,2.94-22.7,9.85a2.42,2.42,0,0,0,1.57,3.88l.75,51.86a3.1,3.1,0,0,0,6.19,0l.76-51.82h40l1.5,51.65a3.32,3.32,0,0,0,6.63,0l.76-52.52L228.54,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.8,90.83A1.79,1.79,0,0,0,52.6,94l1.88,1.69A16.94,16.94,0,0,0,65.79,100h25c1.35,2.12,3.54,2.85,6,3.1,7.42.75,12.87,5.9,13,13.19l1,67.59h-9a6.25,6.25,0,0,0-6.25,6.25v1H132.4v-1a6.25,6.25,0,0,0-6.25-6.25h-9l1-68c.1-7.17,5.4-12.28,12.68-13,2.36-.23,4.47-.91,5.8-2.92h25.47a17,17,0,0,0,11.32-4.33L175.36,94a1.79,1.79,0,0,0-1.2-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.75,12.51a32.29,32.29,0,0,0,15,50.28,8.45,8.45,0,0,1,5.15,4.49l4.23,9.81a2.05,2.05,0,0,0,1.91,1.15,2,2,0,0,0,1.1-.36,2.07,2.07,0,0,0,.74-.89l3.6-9.71a8.44,8.44,0,0,1,5.1-4.82A32.26,32.26,0,1,0,88.75,12.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.2,15.92a2.66,2.66,0,0,1,2,.91,3.42,3.42,0,0,1,.87,2.54,62.16,62.16,0,0,1-.08,8c0,.35-.1.69-.15,1-.31,1.78-.59,3.65-.87,5.63-.19,1.52-.31,3.08-.37,4.65a1.42,1.42,0,0,1-2.83,0c-.07-1.58-.21-3.14-.4-4.67-.25-2-.53-3.85-.86-5.63-.06-.3-.1-.63-.15-1a68.17,68.17,0,0,1,0-8,3.53,3.53,0,0,1,.82-2.54A2.64,2.64,0,0,1,114.2,15.92Zm0,26.69a3.27,3.27,0,0,1,2.3.82,3.08,3.08,0,0,1,0,4.35,3.27,3.27,0,0,1-2.3.82,3.32,3.32,0,0,1-2.34-.82,3.18,3.18,0,0,1,0-4.35A3.32,3.32,0,0,1,114.2,42.61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.0c08b00bd5f42e177f28a7378dd61d26.svg";
export { ForwardRef as ReactComponent };